// vu-loop (SP1) — single rAF loop that reads player VU + playhead and pushes
// them into the track rows + transport. One loop for the whole view replaces
// the scattered per-component polling of the legacy code.

import type { Player } from '../player.js';
import type { TransportHandle } from './transport.js';

/** Строка, которой VU-цикл раздаёт уровень (ячейка дорожки широкого экрана). */
export interface VuRow { trackId: string; setVu: (level: number) => void; }

export interface VuLoopDeps {
  player: Player;
  rows: VuRow[];
  transport: TransportHandle;
}

export interface VuLoop {
  start: () => void;
  stop: () => void;
  /** Single synchronous tick — used by tests; production uses requestAnimationFrame. */
  tickOnce: () => void;
}

export function createVuLoop(deps: VuLoopDeps): VuLoop {
  const { player, rows, transport } = deps;
  let raf: number | null = null;

  const tickOnce = (): void => {
    let masterVu = 0;
    for (const r of rows) {
      const lvl = player.getTrackVuLevel(r.trackId);
      r.setVu(lvl);
      if (lvl > masterVu) masterVu = lvl;
    }
    transport.syncTime(player.getPlayhead(), player.isPlaying(), masterVu);
  };

  const loop = (): void => {
    tickOnce();
    raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame(loop) : null;
  };

  return {
    start: () => { if (raf === null && typeof requestAnimationFrame === 'function') raf = requestAnimationFrame(loop); },
    stop: () => { if (raf !== null && typeof cancelAnimationFrame === 'function') cancelAnimationFrame(raf); raf = null; },
    tickOnce,
  };
}
